import { Direction } from "../../../../types/battle-engine/battle";
import { SkillCastPattern } from ".";

export const CONE_3_PATTERN: SkillCastPattern = () => {
  return {
    [Direction.N]: [
      [0, -1],
      [0, -2],
      [-1, -2],
      [1, -2],
      [0, -3],
      [-1, -3],
      [1, -3],
      [-2, -3],
      [2, -3],
    ],

    [Direction.NE]: [
      [1, -1],
      [1, -2],
      [2, -1],
      [2, -2],
      [1, -3],
      [3, -1],
      [2, -3],
      [3, -2],
      [1, -4],
      [4, -1],
    ],

    [Direction.E]: [
      [1, 0],
      [2, 0],
      [2, -1],
      [2, 1],
      [3, 0],
      [3, -1],
      [3, 1],
      [3, -2],
      [3, 2],
    ],

    [Direction.SE]: [
      [1, 1],
      [1, 2],
      [2, 1],
      [2, 2],
      [1, 3],
      [3, 1],
      [2, 3],
      [3, 2],
      [1, 4],
      [4, 1],
    ],

    [Direction.S]: [
      [0, 1],
      [0, 2],
      [-1, 2],
      [1, 2],
      [0, 3],
      [-1, 3],
      [1, 3],
      [-2, 3],
      [2, 3],
    ],

    [Direction.SW]: [
      [-1, 1],
      [-2, 1],
      [-1, 2],
      [-2, 2],
      [-3, 1],
      [-1, 3],
      [-3, 2],
      [-2, 3],
      [-4, 1],
      [-1, 4],
    ],

    [Direction.W]: [
      [-1, 0],
      [-2, 0],
      [-2, -1],
      [-2, 1],
      [-3, 0],
      [-3, -1],
      [-3, 1],
      [-3, -2],
      [-3, 2],
    ],

    [Direction.NW]: [
      [-1, -1],
      [-2, -1],
      [-1, -2],
      [-2, -2],
      [-3, -1],
      [-1, -3],
      [-3, -2],
      [-2, -3],
      [-4, -1],
      [-1, -4],
    ],
  };
};
